function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffffff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "Graphics"
}, React.createElement("polygon", {
  className: "cls-1",
  points: "131.52 422.32 131.52 366.08 142.15 366.08 142.15 388.74 166.68 388.74 166.68 366.08 177.32 366.08 177.32 422.32 166.68 422.32 166.68 398.59 142.15 398.59 142.15 422.32 131.52 422.32"
}), React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M225.18,382.53v39.89h-10.14v-5.12c-2.56,4.14-6.89,6.3-12.71,6.3s-10.24-1.87-13.99-5.71c-3.74-3.84-5.52-8.86-5.52-15.36s1.97-11.42,5.81-15.27c3.84-3.84,8.37-5.81,13.39-5.81,6.01,0,10.34,1.87,13,5.61v-4.63l10.14.1h0ZM196.13,410.8c2.17,2.17,4.83,3.25,8.17,3.25s5.91-1.08,7.88-3.25c1.87-2.17,2.86-4.92,2.86-8.37s-.98-6.11-2.86-8.37c-1.87-2.27-4.53-3.25-7.88-3.25s-6.01,1.08-8.17,3.25c-2.17,2.17-3.15,4.92-3.15,8.37s.98,6.11,3.15,8.37"
}), React.createElement("path", {
  className: "cls-1",
  d: "M270.39,395.24v27.18h-10.14v-23.05c0-5.71-2.76-8.57-8.08-8.57-2.66,0-4.92,1.08-6.6,3.15-1.67,2.07-2.56,4.83-2.56,8.08v20.29h-10.14v-39.89h10.14v6.4c3.25-5.02,7.78-7.58,13.49-7.58,4.24,0,7.58,1.28,10.14,3.74,2.46,2.66,3.74,6.01,3.74,10.24"
}), React.createElement("path", {
  className: "cls-1",
  d: "M318.15,366.18v56.34h-10.14v-5.61c-1.08,1.97-2.76,3.64-4.92,4.83-2.17,1.28-4.73,1.87-7.58,1.87-5.61,0-10.24-1.87-13.99-5.71-3.74-3.84-5.52-8.96-5.52-15.36s1.97-11.42,5.91-15.27c3.94-3.84,8.47-5.81,13.59-5.81,5.91,0,10.14,1.97,12.61,6.01v-21.27h10.05ZM289.3,410.8c2.17,2.17,4.83,3.25,8.08,3.25s5.81-1.08,7.78-3.25c1.97-2.17,2.95-4.92,2.95-8.37s-.98-6.11-2.95-8.37c-1.97-2.27-4.53-3.25-7.78-3.25s-5.91,1.08-8.08,3.25c-2.17,2.17-3.25,4.92-3.25,8.37,0,3.45,1.08,6.2,3.25,8.37"
}), React.createElement("path", {
  className: "cls-1",
  d: "M333.91,392.38c0,2.46,3.15,4.43,9.36,5.71,4.83.98,8.37,2.46,10.74,4.43,2.27,1.97,3.45,4.63,3.45,7.98,0,3.74-1.48,6.89-4.43,9.36-2.95,2.46-6.99,3.64-12.11,3.64-4.63,0-8.47-1.08-11.42-3.35-2.95-2.27-5.32-5.02-6.8-8.37l8.08-5.22c.89,2.66,2.27,4.83,3.94,6.4,1.77,1.58,3.84,2.36,6.3,2.36,1.67,0,3.15-.39,4.43-1.18,1.28-.79,1.87-1.87,1.87-3.35,0-1.28-.69-2.36-1.97-3.15-1.28-.79-3.55-1.48-6.5-2.07-9.26-1.87-13.89-6.01-13.89-12.61,0-3.64,1.48-6.5,4.33-8.47,2.86-2.07,6.4-3.15,10.54-3.15,4.43,0,7.98.79,10.64,2.46,2.66,1.67,4.83,4.14,6.6,7.68l-7.98,4.43c-1.87-4.73-4.92-7.09-9.16-7.09s-6.01,1.18-6.01,3.55"
})), React.createElement("polygon", {
  className: "cls-1",
  points: "363.85 422.42 363.85 366.18 374.49 366.18 374.49 388.84 399.11 388.84 399.11 366.18 409.75 366.18 409.75 422.42 399.11 422.42 399.11 398.68 374.49 398.68 374.49 422.42 363.85 422.42"
}), React.createElement("path", {
  className: "cls-1",
  d: "M468.35,412.57c3.84-5.02,5.91-11.23,5.91-18.02,0-16.64-12.21-28.76-29.05-28.76s-29.05,12.11-29.05,28.76,12.21,28.76,29.05,28.76c5.81,0,11.23-1.48,15.76-4.14l2.46,3.15h12.31l-7.39-9.75ZM463.43,394.55c0,3.15-.69,6.2-1.87,8.86l-5.91-7.88h-12.51l11.62,15.36c-2.76,1.67-6.01,2.46-9.55,2.46-10.74,0-18.22-7.68-18.22-18.71s7.49-18.71,18.22-18.71c10.74-.2,18.22,7.58,18.22,18.61"
}), React.createElement("path", {
  className: "cls-1",
  d: "M128.56,354.66l-36.15.1-33.39,33.29-16.74-16.84-18.02,18.02,34.87,34.96,69.43-69.53ZM42.29,373.67l14.77,14.77h-29.55l14.77-14.77ZM27.51,390.12h30.73v30.73l-30.73-30.73ZM60.01,420.84v-30.73h30.73l-30.73,30.73ZM91.92,388.44h-30.73l30.73-30.73v30.73ZM93.7,356.43h30.73l-30.73,30.73v-30.73Z"
})));

var SvgHandsHq = function SvgHandsHq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    width: 180,
    height: 150,
    "data-name": "Layer 1",
    viewBox: "125 275 250 250",
    className: "jss842",
    "data-testid": "logo",
    style: {
      backgroundColor: "rgb(144, 26, 29)"
    },
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHandsHq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hands-hq.8030987b.svg";
export { ForwardRef as ReactComponent };